import Bag from 'components/Bag/Bag';
import Cart from 'components/Cart/Cart';
import Checkout from 'components/Checkout/Checkout';
import ProductUtils from 'components/Products/ProductUtils';
import { ApiRequest, getStoreConfiguration } from 'GlobalFunctions';
import { useEffect, useState } from 'react';
import {BrowserRouter as Router , Route, Routes} from 'react-router-dom';
import SubscriptionCheckout from 'components/Checkout/SubscriptionCheckout';
import SubscriptionDetails from 'components/Subscription/Details/Details';

export default function AppRoutes(props: any) {
  const role_id = Number(localStorage.getItem('role_id'));
  
  const [productPage, setProductPage] = useState(false);
  const [cartPage, setCartPage] = useState(false);
  const [checkoutPage, setCheckoutPage] = useState(false);
  const [subscriptionDetailsPage, setSubscriptionDetailsPage] = useState<string | null>(null);

  useEffect(() => {
    checker();
  }, []);

  /* VERIFY PRODUCT CHECKLIST
  ==============================================*/
  const verifyProductChecklist = async () => {
    const storeConfiguration: any = await getStoreConfiguration();
    const isProductChecked = storeConfiguration?.store?.onboarding_checklist?.product === true;
    if (!isProductChecked) {
      ApiRequest({
        url: "/stores/verifyProductChecklist",
        method: "get"
      });
    }
  }

  /* CHECKER
  ==============================================*/
  const checker = () => {

    /* SUBSCRIPTION DETAILS PAGE
    ==============================================*/
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionCode = urlParams.get('subscription');
    const detailsParam = urlParams.get('details');
    if (subscriptionCode && detailsParam === 'true') {
      setSubscriptionDetailsPage(subscriptionCode);
      return;
    }
    
    /* PRODUCT PAGE
    ==============================================*/
    const addToCartForm = document.querySelector("[pc='form']");
    if (addToCartForm) {
      verifyProductChecklist();
      setProductPage(true);
      return;
    }
    
    /* CART PAGE
    ==============================================*/
    if (document.body.getAttribute('pc') === 'cart') {
      setCartPage(true);
      return;
    }
    
    /* CHECKOUT PAGE
    ==============================================*/
    if (document.body.getAttribute('pc') === 'checkout') {
      setCheckoutPage(true);
      return;
    }
  }
  
  /* CHECK IF CART HAS PRODUCTS
  ==============================================*/
  const hasProductsInCart = (): boolean => {
    // Check if subscription parameter exists in URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('subscription')) {
      return false;
    }
    
    const cartData = localStorage.getItem('cart');
    if (!cartData) return false;
    
    try {
      const cart = JSON.parse(cartData);
      return cart.products && Array.isArray(cart.products) && cart.products.length > 0;
    } catch (error) {
      console.error('Error parsing cart data:', error);
      return false;
    }
  }

  /* REDIRECT TO
  ==============================================*/
  const RedirectTo = ({ url }: { url: string }) => {
    useEffect(() => {
      window.location.href = url;
    }, [url]);
    return null;
  };

  return (
    <>
      <Routes>
        {subscriptionDetailsPage &&
          <Route path="*" element={<SubscriptionDetails subscriptionCode={subscriptionDetailsPage} />} />
        }
        {productPage && 
          <Route path="*" element={<ProductUtils />} />
        }
        {cartPage &&
          <Route path="*" element={hasProductsInCart() ? <Cart /> : <RedirectTo url="/" />} />
        }
        {checkoutPage &&
          <Route path="*" element={hasProductsInCart() ? <Checkout /> : <RedirectTo url="/" />} />
        }
        <Route path="*" element={<Bag />} />
        <Route path="pennicart-cart" element={hasProductsInCart() ? <Cart /> : <RedirectTo url="/" />} />
        <Route path="pennicart-checkout" element={hasProductsInCart() ? <Checkout /> : <SubscriptionCheckout />} />
      </Routes>
    </> 
  );
}
